const clientToken = import.meta.env['VITE_PAYMENTS_CLIENT_TOKEN'] as string | undefined;

export function PaymentTestModeBanner() {
  if (!clientToken) {
    return (
      <div className="w-full border-b border-destructive/40 bg-destructive/10 px-4 py-2 text-center text-sm text-destructive">
        Card payments are not finished setting up yet, so checkout can't take real cards.
      </div>
    );
  }
  if (clientToken.startsWith("pk_test_")) {
    return (
      <div className="w-full border-b border-[var(--color-ember)]/40 bg-[var(--color-ember)]/10 px-4 py-2 text-center text-sm text-[var(--color-ember)]">
        Test mode — payments made in the preview are not real charges.
      </div>
    );
  }
  return null;
}
